import { defineKeyframes } from '@pandacss/dev';
import { css } from '@/styled-system/css';

export const shimmerKeyframes = defineKeyframes({
  shimmer: {
    '0%': {
      backgroundPositionX: '-100%',
    },
    '100%': {
      backgroundPositionX: '100%',
    },
  },
});

/**
 * Creates a shimmer loading effect animation for use with PandaCSS.
 * The shimmer moves from left to right across the element by animating the background position.
 * Applies a smooth transition and gradient animation when the _loading state is active.
 * The animation respects the user's reduced motion preferences.
 *
 * @returns {ReturnType<typeof css.raw>} Raw CSS styles object for the shimmer effect
 */
export const shimmerStyles = css.raw({
  transition: 'all 0.3s ease-out',
  _loading: {
    color: 'transparent',
    background: '#f1f1f4 linear-gradient(to right, #f1f1f4, #f9f9fb, #f1f1f4) no-repeat 100%',
    opacity: 'inherit',
    animation: 'shimmer 1.5s linear infinite',
  },

  _motionReduce: {
    animation: 'none',
  },
});
